'use client'

import dynamic from 'next/dynamic'

import type { EventError, FormType, Submission } from '@formio/react'
import '@/styles/formio-overrides.css'

// FormIO needs to be called dynamically to avoid SSR issue even with use client flag added.
const FormioWrapper = dynamic(() => import('@/components/common/Forms/FormioWrapper'), { ssr: false })

export default function FormRenderer({
  schema,
  src,
  onError,
  onSubmitDone,
  type = 'page',
  submission,
}: {
  schema?: FormType
  src?: string
  submission?: Submission
  onError?: ((error: EventError | false) => void) | undefined
  onSubmitDone?: (val: boolean) => void
  type?: 'page' | 'drawer'
}) {
  if (!src) return

  return <FormioWrapper form={schema} src={src} onError={onError} onSubmitForm={onSubmitDone} type={type} submission={submission} />
}
